<template>
  <div class="auth-card">
    <h2 class="auth-title">{{ title }}</h2>
    <form @submit.prevent="handleLogin">
        <div class="form-group">
            <label for="email">Email</label>
            <input
                type="email"
                id="email"
                v-model="email"
                required
                autocomplete="email"
                />
        </div>

        <div class="form-group">
            <label for="password">Password</label>
            <input
                type="password"
                id="password"
                v-model="password"
                required
                autocomplete="current-password"
                />
        </div>

        <p v-if="error" class="error-message"> {{ error }} </p>

        <button type="submit" class="auth-btn login-btn">Log In</button>
    </form>
  </div>
</template>

<script>

import { apiClient } from '@/services/ApiClient'

import axios from 'axios'

export default {
    name: 'UnifiedLogin',
    emits: ['login-success', 'switch-view'],
    props: {
        title: {
            type: String,
            default: 'Login'
        },
    },
    data() {
        return {
            email: '',
            password: '',
            error: null,
        }
    },
   methods: {
    async handleLogin() {
        this.error = null;
        const API_BASE_URL_FOR_LOGIN = 'https://api-afrobraids.inchtechs.com/api'; 
        
        try {
            // basic axios for the initial login POST
            const loginResponse = await axios.post(`${API_BASE_URL_FOR_LOGIN}/auth/login`, {
                 email: this.email,
                 password: this.password
            })
            
            const user = loginResponse.data.user;
            const email = this.email;
            
       
            // Emit success, sending up the necessary token data
            this.$emit('login-success', 
                loginResponse.data,
                user, 
                email,
                user.access_token,
                user.refresh_token
            )

        } catch (error) {
            let message = error.response?.data?.error || 'Login failed. Please check your credentials.';
            this.error = message;
        }
    }
   }
}
</script>
<style scoped>
.auth-card {
    max-width: 400px;
    margin: 50px auto;
    padding: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    background-color: white;
}

.auth-title {
    color: crimson;
    text-align: center;
    margin-bottom: 25px;
    font-size: 1.8rem;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
    color: #555;
}

.form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
    box-sizing: border-box;
}

.auth-btn {
    width: 100%;
    padding: 12px;
    border: none;
    border-radius: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
}

.login-btn {
    background-color: crimson;
    color: white;
}

.login-btn:hover {
    background-color: #c0003c;
}

.auth-footer {
    text-align: center;
    margin-top: 20px;
    font-size: 0.95rem;
    color: #777;
}

.auth-footer a {
    color: crimson;
    text-decoration: none;
    font-weight: 600;
}

.error-message {
    color: red;
    margin-bottom: 15px;
    text-align: center;
}
</style>